import * as React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import { useNavigate, useLocation } from 'react-router'
import { useConfig } from '../hooks/useConfig'

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

// Map routes to tab indices
const routeToTabIndex: Record<string, number> = {
    '/': 0,
    '/projects': 1,
    '/about': 2,
    '/contact': 3,
}

// Map tab indices to routes
const tabIndexToRoute: Record<number, string> = {
    0: '/',
    1: '/projects',
    2: '/about',
    3: '/contact',
}

export default function NavigationTabs() {
    const navigate = useNavigate()
    const location = useLocation()
    const { config } = useConfig()

    // Determine current tab index based on route
    const currentTabIndex = routeToTabIndex[location.pathname] ?? 0

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        const route = tabIndexToRoute[newValue]
        if (route) {
            navigate(route)
        }
    }

    if (!config) {
        return null
    }

    const tabContent = [
        { id: 0, content: config.tabs.home, route: '/' },
        { id: 1, content: config.tabs.projects, route: '/projects' },
        { id: 2, content: config.tabs.about, route: '/about' },
        { id: 3, content: config.tabs.contact, route: '/contact' },
    ]

    return (
        <Box
            sx={{
                width: '100%',
                position: 'sticky',
                top: 0,
                backgroundColor: 'background.paper',
                zIndex: 999,
            }}
        >
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={currentTabIndex}
                    onChange={handleChange}
                    aria-label="navigation tabs"
                >
                    {tabContent.map((tab) => (
                        <Tab
                            key={tab.id}
                            label={tab.content}
                            {...a11yProps(tab.id)}
                        />
                    ))}
                </Tabs>
            </Box>
        </Box>
    )
}
